// context/RestaurantContext.jsx
// 📍 Location: frontend/context/RestaurantContext.jsx

import React, { createContext, useContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSwitchLocationMutation } from '../pages/restaurant/restaruant.service';
import { setUser, setToken } from '../app.slice';

const RestaurantContext = createContext();

export const RestaurantProvider = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.app.user);
  const [activeLocation, setActiveLocation] = useState(null);
  const [locations, setLocations] = useState([]);
  const [switchLocation] = useSwitchLocationMutation();

  useEffect(() => {
    if (user) {
      setActiveLocation(user.activeLocationId || user.locationId || user.restaurantId);
      setLocations(user.locationIds || []);
    }
  }, [user]);

  const switchToLocation = async (locationId) => {
    try {
      const result = await switchLocation({ locationId }).unwrap();
      
      // ✅ Update token
      if (result.data.token) {
        dispatch(setToken(result.data.token));
      }
      
      // ✅ Update user
      if (result.data.user) {
        dispatch(setUser(result.data.user));
      }
      
      setActiveLocation(locationId);
      return result;
    } catch (error) {
      console.error('Failed to switch location:', error);
      throw error;
    }
  };

  return (
    <RestaurantContext.Provider value={{
      activeLocation,
      locations,
      switchToLocation,
      currentRestaurant: locations?.find(l => l?._id === activeLocation)
    }}>
      {children}
    </RestaurantContext.Provider>
  );
};

export const useRestaurantContext = () => useContext(RestaurantContext);